/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetRoleRequest,
  GetRoleSecurity,
} from "../models/operations/getrole.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildRoleQuery,
  prefetchRole,
  queryKeyRole,
  RoleQueryData,
} from "./role.core.js";
export { buildRoleQuery, prefetchRole, queryKeyRole, type RoleQueryData };

export type RoleQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getRole access
 *
 * @remarks
 * Get a role by ID.
 */
export function useRole(
  request: GetRoleRequest,
  security?: GetRoleSecurity | undefined,
  options?: QueryHookOptions<RoleQueryData, RoleQueryError>,
): UseQueryResult<RoleQueryData, RoleQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildRoleQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * getRole access
 *
 * @remarks
 * Get a role by ID.
 */
export function useRoleSuspense(
  request: GetRoleRequest,
  security?: GetRoleSecurity | undefined,
  options?: SuspenseQueryHookOptions<RoleQueryData, RoleQueryError>,
): UseSuspenseQueryResult<RoleQueryData, RoleQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildRoleQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setRoleData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      id: string;
      gramKey?: string | undefined;
      gramSession?: string | undefined;
    },
  ],
  data: RoleQueryData,
): RoleQueryData | undefined {
  const key = queryKeyRole(...queryKeyBase);

  return client.setQueryData<RoleQueryData>(key, data);
}

export function invalidateRole(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      id: string;
      gramKey?: string | undefined;
      gramSession?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "access", "getRole", ...queryKeyBase],
  });
}

export function invalidateAllRole(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "access", "getRole"],
  });
}
